export default __webpack_public_path__ + "static/media/tardis.372721c5.png";